import { useCallback, useContext, useState } from "react";
import { v4 } from "uuid";
import analytics from "../analytics/analytics.js";
import { ChatbotDataContext } from "../context/ChatbotDataContext.js";
import { feedbackPost } from "../utils/feedbackPost.js";
function useMessageFeedback(message) {
    const { submitChatMessagesPayload, fetchRequestOptions } = useContext(ChatbotDataContext);
    const { rguid, cguid } = submitChatMessagesPayload ?? {};
    const [voteSubmitted, setVoteSubmitted] = useState(false);
    const submitFeedback = useCallback(async (vote, feedback)=>{
        const feedbackId = v4();
        const pennysid = 'undefined' != typeof window ? sessionStorage.getItem('pennysid') : void 0;
        try {
            if (!voteSubmitted) {
                const { headers } = fetchRequestOptions;
                const baseUrl = '/genai-svc/genai/chat/feedback';
                await feedbackPost({
                    feedback: feedback ?? '',
                    message: {
                        ...message,
                        vote
                    },
                    conversationId: rguid,
                    feedbackId,
                    cguid,
                    pennysid
                }, baseUrl, headers);
                setVoteSubmitted(true);
            }
        } catch (e) {
            analytics.log({
                source: 'feedback error',
                message: e,
                cguid,
                feedbackId,
                conversationId: rguid
            });
        }
    }, [
        message,
        rguid,
        cguid,
        fetchRequestOptions,
        voteSubmitted
    ]);
    return {
        submitFeedback,
        voteSubmitted
    };
}
export { useMessageFeedback };
